import type { ExportEnvelope } from '../../domain/backup/ExportEnvelope';
import type { ProfileId } from '../../domain/shared/ids';
import { failure, success, type Result } from '../../domain/shared/Result';
import { RoutineError, toRoutineError } from '../errors/RoutineError';
import type { BackupTransactions } from '../ports/BackupTransactions';
import type { Clock } from '../ports/Clock';

export class ExportProfileData {
  public constructor(
    private readonly transactions: BackupTransactions,
    private readonly clock: Clock,
  ) {}

  public async execute(profileId: ProfileId): Promise<Result<ExportEnvelope, RoutineError>> {
    try {
      const exportedAt = this.clock.now().toISOString();
      return success(await this.transactions.exportProfileData(profileId, exportedAt));
    } catch (error) {
      return failure(toRoutineError(error));
    }
  }
}
